"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportColumnPickerDialog = void 0;
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const calcUniqueKeyForViewField_1 = __importDefault(require("@opsbase/lib-data-viewfield/helpers/calcUniqueKeyForViewField"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const ViewSpinner_1 = __importDefault(require("@opsbase/web-ctrl-view/ViewSpinner"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const Columns_1 = __importDefault(require("@opsbase/web-layout/Columns"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const useParams_1 = __importDefault(require("@opsbase/web-nav/useParams"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    menuItem: {
        margin: '0 8px',
        padding: '4px 8px',
        flex: 1,
        backgroundColor: 'white',
        borderRadius: 4,
    },
    colsBit: {
        opacity: 1,
        height: '100%',
        pointerEvents: 'unset',
        transition: 'opacity 0.3s, height 0.3s',
    },
});
function ReportColumnPickerDialog() {
    const { viewId, fieldSelector } = (0, useParams_1.default)();
    return (react_1.default.createElement(ViewSpinner_1.default, { viewId: viewId },
        react_1.default.createElement(ReportColumnPickerDialogInner, { viewId: viewId, fieldSelector: fieldSelector })));
}
exports.ReportColumnPickerDialog = ReportColumnPickerDialog;
function ReportColumnPickerDialogInner({ viewId, fieldSelector }) {
    const { fields, type } = (0, useView_1.default)(viewId);
    const { setFields } = (0, useViewActions_1.default)(viewId);
    const { goBack } = (0, useNav_1.default)();
    const [localFields, setLocalFields] = (0, react_1.useState)(fields);
    const metaModel = MetaModelRegistry_1.default[type];
    const availableFields = (0, react_1.useMemo)(() => {
        if (fieldSelector) {
            return fieldSelector(metaModel.fields);
        }
        return metaModel.fields;
    }, [fieldSelector, metaModel.fields]);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const allFields = (0, react_1.useMemo)(() => (0, uniqBy_1.default)([...availableFields, ...localFields], calcUniqueKeyForViewField_1.default).filter(f => f.key !== ViewFieldKey_1.default.ROWKEY), [availableFields, localFields]);
    const handleToggleColumn = (0, useCallforward_1.default)(field => () => {
        if (field.key === ViewFieldKey_1.default.QUESTIONANSWER) {
            setLocalFields(localFields.map(f => (Object.assign(Object.assign({}, f), { hidden: f === field ? !f.hidden : f.hidden }))));
        }
        else if (localFields.find(f => f.key === field.key)) {
            setLocalFields(localFields.filter(f => f.key !== field.key));
        }
        else {
            setLocalFields([...localFields, field]);
        }
    }, [localFields]);
    const handleClickOk = (0, react_1.useCallback)(() => {
        setFields(localFields);
        goBack();
    }, [setFields, localFields, goBack]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X800_Y400, scroll: false, title: lib_i18n_1.default.t('choose-columns'), buttonsRight: react_1.default.createElement(Button_1.default, { label: lib_i18n_1.default.t('ok'), color: lib_palette_1.default.positive, onClick: handleClickOk }) },
        react_1.default.createElement(Columns_1.default, { scroll: true, classes: { root: myCss.colsBit }, noOfCols: 2 }, allFields.map(f => {
            const inLocalFields = !!localFields.find(ff => ff.key === f.key);
            const disabled = localFields.findIndex(ff => ff.key === f.key) === 0;
            const isQuestionAnswer = f.key === ViewFieldKey_1.default.QUESTIONANSWER;
            const dontTick = isQuestionAnswer && f.hidden;
            const key = (0, calcUniqueKeyForViewField_1.default)(f);
            return (react_1.default.createElement(Horizontal_1.default, { key: key, shrink: true, gutter: true, centered: true },
                react_1.default.createElement(MenuItem_1.default, { classes: { root: myCss.menuItem }, disabled: disabled, leftTick: true, showTick: inLocalFields && !dontTick, onClick: handleToggleColumn(f) },
                    react_1.default.createElement(Vertical_1.default, { justify: "flex-start", style: { maxWidth: 350, overflowX: 'auto' } },
                        react_1.default.createElement(Text_1.default, null, (0, getFromStringOrFunction_1.getFromStringOrFunction)(f.label)),
                        react_1.default.createElement(Text_1.default, { variant: "small" }, (0, getFromStringOrFunction_1.getFromStringOrFunction)(f.description))))));
        })))), [allFields, handleClickOk, handleToggleColumn, localFields, myCss]);
}
exports.default = ReportColumnPickerDialog;
